import type { Beat, Chart, Measure } from './chart-types';

const BEATS_PER_MEASURE = 4;

export function parseChart(source: string): Chart {
  const measureStrings = source
    .split('|')
    .map((measure) => measure.trim())
    .filter(Boolean);

  let currentChord: string | undefined;

  const measures = measureStrings.map((measureSource, measureIndex) => {
    const tokens = measureSource.split(/\s+/).filter(Boolean);

    if (tokens.length !== BEATS_PER_MEASURE) {
      throw new Error(
        `Measure ${measureIndex + 1} has ${tokens.length} beat tokens; ` +
          `expected ${BEATS_PER_MEASURE}.`,
      );
    }

    const beats = tokens.map((token, beatIndex): Beat => {
      const startsChord = token !== '.';

      if (startsChord) {
        currentChord = token;
      }

      if (!currentChord) {
        throw new Error(
          `Measure ${measureIndex + 1}, beat ${beatIndex + 1} ` +
            `continues a chord before any chord was defined.`,
        );
      }

      return {
        chord: currentChord,
        startsChord,
      };
    });

    return {
      beats: beats as Measure['beats'],
    };
  });

  return { measures };
}
